/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconHelpAltActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.01-1.945a1.125 1.125 0 0 1 2.25 0c0 .205-.045.372-.214.601-.113.154-.24.234-.526.411l-.147.092c-.32.201-.62.46-.827.846-.202.379-.274.806-.274 1.277h1.5c0-.325.05-.483.097-.57.043-.08.117-.167.302-.283l.112-.068c.273-.166.674-.41.973-.818.347-.473.503-.948.503-1.488a2.625 2.625 0 1 0-5.13.784L7.06 6.39a1.124 1.124 0 0 1-.05-.336zm.24 4.47v1.5h1.5v-1.5h-1.5z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm9.441-2.28a1.72 1.72 0 0 1 3.442 0c0 .317-.072.578-.327.926-.174.237-.376.363-.788.619l-.213.133c-.456.287-.88.653-1.169 1.194-.284.533-.387 1.137-.387 1.812V15h2v-.595c0-.481.075-.726.151-.87.072-.133.193-.27.47-.443l.164-.1c.398-.243.962-.586 1.385-1.163.494-.672.714-1.344.714-2.108a3.72 3.72 0 1 0-7.273 1.112l1.91-.597a1.72 1.72 0 0 1-.079-.515zM11 17v2h2v-2h-2z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconHelpAltActive is deprecated and will be archived soon. Use IconHelpAltActive instead.
 */
export function Experimental__IconHelpAltActive(props) {
  return /*#__PURE__*/React.createElement(IconHelpAltActive, props);
}